export default __webpack_public_path__ + "static/media/marker-sky-orange.82c5e604.png";